import { useEffect } from 'react';

const useResizeListener = handler => {
  useEffect(() => {
    window.addEventListener('resize', handler, { passive: false });

    return () => {
      window.removeEventListener('resize', handler, { passive: false });
    };
  }, [handler]);
};

export default useResizeListener;
